export const workBeganData = {
  title: 'When did the building work/service begin?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/aea862695be0-tooliconcalendar.jpg',
  },
}
